export default __webpack_public_path__ + "static/sc-customize-tags-114490e06fe2903d6ce258dd43017c0f.mp4";